import { render, staticRenderFns } from "./RequestsByBusinessArea.vue?vue&type=template&id=7378b7e8&"
import script from "./RequestsByBusinessArea.vue?vue&type=script&lang=js&"
export * from "./RequestsByBusinessArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports